import type {
  ShopPromotionRecord,
  ShopPromotionType,
} from '../types/shopPromotion';
import { formatCurrencyVND } from './transactionHelpers';
import { formatVnDateTime } from './vnDateTime';

export function promotionTypeLabel(type: ShopPromotionType | string): string {
  switch (type) {
    case 'percentage':
      return 'Giảm %';
    case 'fixed_amount':
      return 'Giảm cố định';
    case 'bxgy':
      return 'Mua tặng (BXGY)';
    case 'combo':
      return 'Combo món';
    default:
      return String(type);
  }
}

export function promotionTypeColor(type: string): string {
  switch (type) {
    case 'percentage':
      return 'blue';
    case 'fixed_amount':
      return 'cyan';
    case 'bxgy':
      return 'purple';
    case 'combo':
      return 'orange';
    default:
      return 'default';
  }
}

export function parsePromotionMetadata(
  raw: ShopPromotionRecord['metadata']
): Record<string, unknown> {
  if (!raw) return {};
  if (typeof raw === 'object') return raw as Record<string, unknown>;
  try {
    return JSON.parse(raw) as Record<string, unknown>;
  } catch {
    return {};
  }
}

export function formatPromotionValueSummary(
  record: ShopPromotionRecord
): string {
  const meta = parsePromotionMetadata(record.metadata);
  const val = Number(record.discount_value) || 0;
  switch (record.discount_type) {
    case 'percentage':
      return `${val}%`;
    case 'fixed_amount':
      return formatCurrencyVND(val);
    case 'bxgy': {
      const buy = (meta.buy_items ?? meta.buyItems) as unknown[] | undefined;
      const gift = (meta.gift_items ?? meta.giftItems) as unknown[] | undefined;
      return `Mua ${buy?.length ?? 0} · Tặng ${gift?.length ?? 0}`;
    }
    case 'combo': {
      const price = Number(meta.combo_price ?? meta.comboPrice) || val;
      const items = (meta.combo_items ?? meta.comboItems) as
        | unknown[]
        | undefined;
      return `${formatCurrencyVND(price)} · ${items?.length ?? 0} món`;
    }
    default:
      return String(val);
  }
}

export function formatDateTimeRange(start: string, end: string): string {
  const fmt = (s: string) => {
    const formatted = formatVnDateTime(s);
    return formatted === '—' ? '–' : formatted;
  };
  return `${fmt(start)} → ${fmt(end)}`;
}
